module.exports = __webpack_public_path__ + "static/media/alert-red.ad971786.svg";